import { z } from 'zod';

export const declarationViewGoodHVSchema = z.object({
  goodShipmentGlobal: z.object({
    totalQuantitySupplementaryUnits: z.preprocess((val) => (val === '' ? null : val), z.number().optional().nullable()),
    firstItemData: z.object({
      nationalAdditionalCode: z.string().optional().nullable(),
      nationalAdditionalCode2: z.string().optional().nullable(),
      nationalAdditionalCode3: z.string().optional().nullable(),
      taricAdditionalCode: z.string().optional().nullable(),
      taricAdditionalCode2: z.string().optional().nullable(),
      hsCode: z.string().optional().nullable(),
      typeOfGoods: z.string().optional().nullable(),
      cusCode: z.string().optional().nullable(),
      invoiceDescription: z.string().optional().nullable(),
    }),
    totalQuantity: z.number().optional().nullable(),
    totalNumberOfPackages: z.number().optional().nullable(),
    totalNetMass: z.number().optional().nullable(),
    totalGrossMass: z.number().optional().nullable(),
    totalAmountInvoiced: z.number().optional().nullable(),
  }),
  otherDataElements: z.object({
    quotaOrderNumber: z.string().optional().nullable(),
  }),
  consignment: z.object({
    countryOfOrigin: z.string().optional().nullable(),
    regionOfOrigin: z.string().optional().nullable(),
    countryOfPreferentialOrigin: z.string().optional().nullable(),
  }),
  declarationGoods: z.object({
    evalMethodAiHsCode: z.object({
      taricSupplementaryUnits: z.array(
        z.object({
          abbreviation: z.string().optional().nullable(),
          codeQualifyer: z.string().optional().nullable(),
        }),
      ),
      codeQualifyer: z.string().optional().nullable(),
    }),
    dutiesAndTaxes: z.object({
      items: z.array(
        z.object({
          taxType: z.string().optional().nullable(),
          taxBase: z.array(
            z.object({
              measurementUnitAndQualifier: z.string().optional().nullable(),
            }),
          ),
        }),
      ),
    }),
    dangerousGoods: z
      .object({
        UNDG: z.array(z.string().optional().nullable()),
      })
      .optional(),
  }),
});

export type DeclarationViewGoodHVFormValues = z.infer<typeof declarationViewGoodHVSchema>;
